import axios from "axios";
import { getBackendUrl } from "../config";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
});

// Register at module level so the token is always attached before any component mounts
api.interceptors.request.use(
	config => {
		const raw = localStorage.getItem("token");
		if (raw) {
			try {
				config.headers["Authorization"] = `Bearer ${JSON.parse(raw)}`;
			} catch {}
		}
		return config;
	},
	error => Promise.reject(error)
);

api.interceptors.response.use(
	response => response,
	async error => {
		const originalRequest = error.config;

		// 403 = access token expired — refresh silently and replay
		if (error?.response?.status === 403 && !originalRequest._retry) {
			originalRequest._retry = true;
			try {
				const { data } = await api.post("/auth/refresh_token");
				localStorage.setItem("token", JSON.stringify(data.token));
				api.defaults.headers.Authorization = `Bearer ${data.token}`;
				originalRequest.headers["Authorization"] = `Bearer ${data.token}`;
				return api(originalRequest);
			} catch {
				localStorage.removeItem("token");
				api.defaults.headers.Authorization = undefined;
				if (window.location.pathname !== "/login") {
					window.location.href = "/login";
				}
				return Promise.reject(error);
			}
		}

		// 401 = session fully expired — redirect to login
		if (error?.response?.status === 401) {
			localStorage.removeItem("token");
			api.defaults.headers.Authorization = undefined;
			if (window.location.pathname !== "/login") {
				window.location.href = "/login";
			}
		}

		return Promise.reject(error);
	}
);

export default api;
